import React from 'react'

export const VideoContext = React.createContext()

const VideoProvider = ( { children } ) => {
    const [ video, setVideo ] = React.useState( [] )

    return (
        <VideoContext.Provider value={ { video, setVideo } } >
            { children }
        </VideoContext.Provider>
    )
}

export default VideoProvider